module.exports = __webpack_public_path__ + "img/littl_girls5.aec73bc2.jpg";